'use strict';

var moment = require('moment');
var isNil = require('lodash/isNil');
var difference = require('lodash/difference');

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value) {
  var validationOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var datePartsRequiredKeys = validationOptions.datePartsRequiredKeys || ['year'];
  var valueKeys = Object.keys(value);
  var containsAllRequiredKeys = !difference(datePartsRequiredKeys, valueKeys).length;

  var valueValidForKey = function valueValidForKey(key) {
    var partValue = value[key];
    var valueIsNumber = typeof partValue === 'number';

    if (datePartsRequiredKeys.includes(key)) return valueIsNumber;

    return valueIsNumber || isNil(partValue);
  };

  return containsAllRequiredKeys && valueKeys.every(valueValidForKey) && moment(value).isValid();
}, 'Value must be a valid date parts object');